import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { saveAs } from "file-saver";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian from "react-date-object/calendars/gregorian";
import api from "../../api.js";

const ReportDownloader = () => {
  const [fields, setFields] = useState([]);
  const [fieldId, setFieldId] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const token = Cookies.get("access_token");
  const [isDownloading, setIsDownloading] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    api
      .get("/field/myfields/", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setFields(res.data))
      .catch((err) => console.error("Error fetching fields", err));
  }, []);

  const handleDownload = async () => {
    const params = new URLSearchParams();

    if (fieldId) params.append("field_id", fieldId);

    if (fromDate) {
      params.append(
        "from_date",
        fromDate.convert(gregorian).format("YYYY-MM-DD")
      );
    }

    if (toDate) {
      params.append(
        "to_date",
        toDate.convert(gregorian).format("YYYY-MM-DD")
      );
    }

    setIsDownloading(true);
    setProgress(0);

    try {
      const response = await api.get(`/report/download/?${params.toString()}`, {
        responseType: "blob",
        headers: { Authorization: `Bearer ${token}` },

        onDownloadProgress: (event) => {
          if (event.total) {
            const percent = Math.round((event.loaded * 100) / event.total);
            setProgress(percent);
          }
        },
      });

      const blob = new Blob([response.data], { type: "application/zip" });
      saveAs(blob, "filtered_reports.zip");

    } catch (err) {
      console.error(err);
      alert("خطا در دانلود فایل‌ها");
    } finally {
      setIsDownloading(false);
      setProgress(0);
    }
  };

  return (
    <div className="download-container wrap-flex">
      <div className="row g-3 mb-4">

        <div className="col-md-4">
          <label className="form-label">انتخاب حوزه</label>
          <select
            className="form-select"
            value={fieldId}
            onChange={(e) => setFieldId(Number(e.target.value))}
          >
            <option value="">همه حوزه‌ها</option>
            {fields.map((field) => (
              <option key={field.id} value={field.id}>
                {field.title}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-4">
          <label className="form-label">از تاریخ</label>
          <DatePicker
            value={fromDate}
            onChange={setFromDate}
            calendar={persian}
            locale={persian_fa}
            calendarPosition="bottom-right"
            inputClass="form-control"
            format="YYYY-MM-DD"
          />
        </div>

        <div className="col-md-4">
          <label className="form-label">تا تاریخ</label>
          <DatePicker
            value={toDate}
            onChange={setToDate}
            calendar={persian}
            locale={persian_fa}
            calendarPosition="bottom-right"
            inputClass="form-control"
            format="YYYY-MM-DD"
          />
        </div>
      </div>

      <button onClick={handleDownload} className="mt-4 btn btn-primary">
        دانلود
      </button>

      {isDownloading && (
        <div className="mt-3">
          <div className="progress">
            <div
              className="progress-bar progress-bar-striped progress-bar-animated"
              role="progressbar"
              style={{ width: `${progress}%` }}
            >
              {progress}%
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReportDownloader;
